import React from 'react';

// "Managed in GoHighLevel · Edit in GHL" — the line beside anything the GHL / Arive guards own.
// `note` is { text, href, link }; the link is hidden when the server sent no URL.
export default function ManagedNote({ note, testId }) {
  if (!note) return null;
  return (
    <span className="text-xs text-slate-500" data-testid={testId}>
      {note.text}
      {note.href && (
        <>
          {' · '}
          <a href={note.href} target="_blank" rel="noreferrer" data-testid={`${testId}-link`}
            className="font-semibold underline" style={{ color: '#070B5F' }}>{note.link}</a>
        </>
      )}
    </span>
  );
}
